// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class UserSummary {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string | null;
  readonly emailAddress: string;
  readonly phoneNumber: string | null;
  readonly canReceiveEmail: boolean;
  readonly isDeactivated: boolean;
  readonly roles: string;
  readonly isSalesperson: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.firstName = data.firstName === undefined ? '' : data.firstName;
    this.lastName = data.lastName === undefined ? null : data.lastName;
    this.emailAddress = data.emailAddress === undefined ? '' : data.emailAddress;
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
    this.canReceiveEmail = data.canReceiveEmail === undefined ? false : data.canReceiveEmail;
    this.isDeactivated = data.isDeactivated === undefined ? false : data.isDeactivated;
    this.roles = data.roles === undefined ? '' : data.roles;
    this.isSalesperson = data.isSalesperson === undefined ? false : data.isSalesperson;
  }

  static zero(): UserSummary {
    const zeroValues: ExcludeMethodsDeep<UserSummary> = {
      id: NIL_UUID,
      firstName: '',
      lastName: null,
      emailAddress: '',
      phoneNumber: null,
      canReceiveEmail: false,
      isDeactivated: false,
      roles: '',
      isSalesperson: false,
    };
    return new UserSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  fullName(): string {
    return `${this.firstName}${this.lastName === null ? '' : ` ${this.lastName}`}`;
  }
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UserSummaryWireFormat = {
  id: string;
  firstName: string;
  lastName: string | null;
  emailAddress: string;
  phoneNumber: string | null;
  canReceiveEmail: boolean;
  isDeactivated: boolean;
  roles: string;
  isSalesperson: boolean;
};

type NewUserSummaryProps = PartialDeep<UserSummary, { recurseIntoArrays: true }>;
export const NewUserSummary: (props: NewUserSummaryProps) => UserSummary = (props) =>
  new UserSummary(props);

type NewUserSummaryFromWireFormatProps = PartialDeep<
  UserSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUserSummaryFromWireFormat: (
  props: NewUserSummaryFromWireFormatProps,
) => UserSummary = (props) => new UserSummary(props);
